/* tslint:disable */
/* eslint-disable */
/* @relayHash f87493f46f23a2d9c1e1324337ade74b */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_STATUS = "APPROVED" | "NONE" | "PREMOD" | "REJECTED" | "SYSTEM_WITHHELD" | "%future added value";
export type TAG = "ADMIN" | "EXPERT" | "FEATURED" | "MEMBER" | "MODERATOR" | "QUESTION" | "REVIEW" | "STAFF" | "UNANSWERED" | "%future added value";
export type CreateCommentReplyInput = {
    nudge?: boolean | null;
    storyID: string;
    parentID: string;
    parentRevisionID: string;
    body: string;
    clientMutationId: string;
    media?: CreateCommentMediaInput | null;
};
export type CreateCommentMediaInput = {
    type: string;
    id?: string | null;
    url: string;
    width?: string | null;
    height?: string | null;
};
export type CreateCommentReplyMutationVariables = {
    input: CreateCommentReplyInput;
    flattenReplies: boolean;
};
export type CreateCommentReplyMutationResponse = {
    readonly createCommentReply: {
        readonly edge: {
            readonly cursor: unknown;
            readonly node: {
                readonly id: string;
                readonly status: COMMENT_STATUS;
                readonly story: {
                    readonly settings: {
                        readonly live: {
                            readonly enabled: boolean;
                        };
                    };
                };
                readonly parent: {
                    readonly id: string;
                    readonly tags: ReadonlyArray<{
                        readonly code: TAG;
                    }>;
                } | null;
                readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabCommentContainer_comment">;
            };
        };
        readonly clientMutationId: string;
    };
};
export type CreateCommentReplyMutation = {
    readonly response: CreateCommentReplyMutationResponse;
    readonly variables: CreateCommentReplyMutationVariables;
};



/*
mutation CreateCommentReplyMutation(
  $input: CreateCommentReplyInput!
  $flattenReplies: Boolean!
) {
  createCommentReply(input: $input) {
    edge {
      cursor
      node {
        ...AllCommentsTabCommentContainer_comment
        id
        status
        story {
          settings {
            live {
              enabled
            }
          }
          id
        }
        parent {
          id
          tags {
            code
          }
        }
      }
    }
    clientMutationId
  }
}

fragment AllCommentsTabCommentContainer_comment on Comment {
  id
  seen
  ...CommentContainer_comment
  ...ReplyListContainer1_comment
  ...IgnoredTombstoneOrHideContainer_comment
  ...DeletedTombstoneContainer_comment
}

fragment ArchivedReportFlowContainer_comment on Comment {
  id
  story {
    url
    id
  }
}

fragment CaretContainer_comment on Comment {
  id
  ...ModerationDropdownContainer_comment
}

fragment CommentContainer_comment on Comment {
  id
  author {
    id
    username
    avatar
    badges
  }
  parent {
    id
    author {
      username
      id
    }
  }
  body
  createdAt
  status
  rating
  editing {
    edited
    editableUntil
  }
  tags {
    code
  }
  deleted
  actionCounts {
    reaction {
      total
    }
  }
  viewerActionPresence {
    dontAgree
    flag
  }
  seen
  canReply
  ...CaretContainer_comment
  ...EditCommentFormContainer_comment
  ...MediaSectionContainer_comment
  ...ReactionButtonContainer_comment
  ...ModerationRejectedTombstoneContainer_comment
  ...ReplyCommentFormContainer_comment
  ...ReportButton_comment
  ...ReportFlowContainer_comment
  ...UsernameContainer_comment
  ...UsernameWithPopoverContainer_comment
  ...UserTagsContainer_comment
  ...ArchivedReportFlowContainer_comment
}

fragment DeletedTombstoneContainer_comment on Comment {
  deleted
  id
}

fragment EditCommentFormContainer_comment on Comment {
  id
  body
  createdAt
  revision {
    id
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
  }
  author {
    username
    id
  }
  editing {
    editableUntil
  }
  site {
    id
  }
}

fragment IgnoredTombstoneOrHideContainer_comment on Comment {
  id
  author {
    id
    username
  }
}

fragment LocalReplyListContainer_comment on Comment {
  id
}

fragment MediaSectionContainer_comment on Comment {
  id
  site {
    id
  }
  revision {
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
    id
  }
}

fragment ModerationActionsContainer_comment on Comment {
  id
  author {
    id
  }
  revision {
    id
  }
  status
  tags {
    code
  }
}

fragment ModerationDropdownContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  status
  tags {
    code
  }
  ...ModerationActionsContainer_comment
  ...UserBanPopoverContainer_comment
}

fragment ModerationRejectedTombstoneContainer_comment on Comment {
  id
}

fragment ReactionButtonContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  viewerActionPresence {
    reaction
  }
  actionCounts {
    reaction {
      total
    }
  }
}

fragment ReplyCommentFormContainer_comment on Comment {
  id
  site {
    id
  }
  author {
    username
    id
  }
  revision {
    id
  }
  ...ReplyEditedWarningContainer_comment
}

fragment ReplyEditedWarningContainer_comment on Comment {
  editing {
    edited
  }
  revision {
    id
  }
}

fragment ReplyListCommentContainer_comment on Comment {
  ...CommentContainer_comment
  ...IgnoredTombstoneOrHideContainer_comment
  ...DeletedTombstoneContainer_comment
}

fragment ReplyListContainer1_comment on Comment {
  id
  status
  replies(first: 10, orderBy: CREATED_AT_ASC) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainer2_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer2_comment on Comment {
  id
  status
  replies(first: 10, orderBy: CREATED_AT_ASC) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainer3_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer3_comment on Comment {
  id
  status
  replies(first: 10, orderBy: CREATED_AT_ASC) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainer4_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer4_comment on Comment {
  id
  status
  replies(first: 10, orderBy: CREATED_AT_ASC) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainer5_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer5_comment on Comment {
  id
  status
  replies(first: 10, orderBy: CREATED_AT_ASC) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainer6_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer6_comment on Comment {
  id
  status
  replies(first: 10, orderBy: CREATED_AT_ASC) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainerLast_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainerLastFlattened_comment on Comment {
  id
  status
  replies(first: 10, orderBy: CREATED_AT_ASC, flatten: $flattenReplies) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        __typename
      }
      __typename
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainerLast_comment on Comment {
  ...LocalReplyListContainer_comment @skip(if: $flattenReplies)
  ...ReplyListContainerLastFlattened_comment @include(if: $flattenReplies)
}

fragment ReportButton_comment on Comment {
  id
  author {
    username
    id
  }
  viewerActionPresence {
    dontAgree
    flag
  }
}

fragment ReportCommentFormContainer_comment on Comment {
  id
  revision {
    id
  }
}

fragment ReportFlowContainer_comment on Comment {
  ...ReportCommentFormContainer_comment
  id
  viewerActionPresence {
    dontAgree
    flag
  }
}

fragment UserBanPopoverContainer_comment on Comment {
  id
  revision {
    id
  }
  status
  author {
    id
    username
  }
}

fragment UserIgnorePopoverContainer_user on User {
  id
  username
}

fragment UserPopoverContainer_user on User {
  id
  ...UserPopoverOverviewContainer_user
  ...UserIgnorePopoverContainer_user
}

fragment UserPopoverOverviewContainer_user on User {
  id
  username
  createdAt
  ignoreable
  bio
}

fragment UserTagsContainer_comment on Comment {
  tags {
    code
  }
}

fragment UsernameContainer_comment on Comment {
  id
  author {
    username
    id
  }
}

fragment UsernameWithPopoverContainer_comment on Comment {
  id
  author {
    id
    username
    ...UserPopoverContainer_user
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "flattenReplies"
    } as any), v1 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    } as any), v2 = [
        ({
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any)
    ], v3 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    } as any), v4 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v5 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    } as any), v6 = ({
        "alias": null,
        "args": null,
        "concreteType": "StorySettings",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "LiveConfiguration",
                "kind": "LinkedField",
                "name": "live",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "enabled",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v7 = ({
        "alias": null,
        "args": null,
        "concreteType": "Tag",
        "kind": "LinkedField",
        "name": "tags",
        "plural": true,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v8 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
    } as any), v9 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "seen",
        "storageKey": null
    } as any), v10 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
    } as any), v11 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
    } as any), v12 = ({
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            (v4 /*: any*/),
            (v10 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "avatar",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "badges",
                "storageKey": null
            },
            (v11 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ignoreable",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bio",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v13 = ({
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            (v10 /*: any*/),
            (v4 /*: any*/)
        ],
        "storageKey": null
    } as any), v14 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "body",
        "storageKey": null
    } as any), v15 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rating",
        "storageKey": null
    } as any), v16 = ({
        "alias": null,
        "args": null,
        "concreteType": "EditInfo",
        "kind": "LinkedField",
        "name": "editing",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "edited",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "editableUntil",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v17 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted",
        "storageKey": null
    } as any), v18 = ({
        "alias": null,
        "args": null,
        "concreteType": "ActionCounts",
        "kind": "LinkedField",
        "name": "actionCounts",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ReactionActionCounts",
                "kind": "LinkedField",
                "name": "reaction",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "total",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v19 = ({
        "alias": null,
        "args": null,
        "concreteType": "ActionPresence",
        "kind": "LinkedField",
        "name": "viewerActionPresence",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dontAgree",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "flag",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reaction",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v20 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "canReply",
        "storageKey": null
    } as any), v21 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any), v22 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    } as any), v23 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
    } as any), v24 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
    } as any), v25 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentRevision",
        "kind": "LinkedField",
        "name": "revision",
        "plural": false,
        "selections": [
            (v4 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "media",
                "plural": false,
                "selections": [
                    (v21 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v22 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                            },
                            (v23 /*: any*/),
                            (v24 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "still",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "video",
                                "storageKey": null
                            }
                        ],
                        "type": "GiphyMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v22 /*: any*/),
                            (v23 /*: any*/)
                        ],
                        "type": "TwitterMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v22 /*: any*/),
                            (v23 /*: any*/),
                            (v24 /*: any*/)
                        ],
                        "type": "YouTubeMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v22 /*: any*/)
                        ],
                        "type": "ExternalMedia",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v26 = ({
        "alias": null,
        "args": null,
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": [
            (v4 /*: any*/)
        ],
        "storageKey": null
    } as any), v27 = ({
        "kind": "Literal",
        "name": "first",
        "value": 10
    } as any), v28 = ({
        "kind": "Literal",
        "name": "orderBy",
        "value": "CREATED_AT_ASC"
    } as any), v29 = [
        (v27 /*: any*/),
        (v28 /*: any*/)
    ], v30 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "replyCount",
        "storageKey": null
    } as any), v31 = ({
        "alias": null,
        "args": null,
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "parent",
        "plural": false,
        "selections": [
            (v4 /*: any*/),
            (v13 /*: any*/)
        ],
        "storageKey": null
    } as any), v32 = ({
        "alias": null,
        "args": null,
        "concreteType": "Story",
        "kind": "LinkedField",
        "name": "story",
        "plural": false,
        "selections": [
            (v22 /*: any*/),
            (v4 /*: any*/)
        ],
        "storageKey": null
    } as any), v33 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pending",
        "storageKey": null
    } as any), v34 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastViewerAction",
        "storageKey": null
    } as any), v35 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasTraversalFocus",
        "storageKey": null
    } as any), v36 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enteredLive",
        "storageKey": null
    } as any), v37 = ({
        "kind": "ClientExtension",
        "selections": [
            (v33 /*: any*/),
            (v34 /*: any*/),
            (v35 /*: any*/),
            (v36 /*: any*/)
        ]
    } as any), v38 = [
        ({
            "alias": null,
            "args": null,
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "localReplies",
            "plural": true,
            "selections": [
                (v4 /*: any*/),
                (v36 /*: any*/),
                (v12 /*: any*/),
                (v31 /*: any*/),
                (v14 /*: any*/),
                (v11 /*: any*/),
                (v5 /*: any*/),
                (v15 /*: any*/),
                (v16 /*: any*/),
                (v7 /*: any*/),
                (v33 /*: any*/),
                (v34 /*: any*/),
                (v17 /*: any*/),
                (v18 /*: any*/),
                (v19 /*: any*/),
                (v35 /*: any*/),
                (v9 /*: any*/),
                (v20 /*: any*/),
                (v25 /*: any*/),
                (v26 /*: any*/),
                (v32 /*: any*/)
            ],
            "storageKey": null
        } as any)
    ], v39 = [
        (v27 /*: any*/),
        ({
            "kind": "Variable",
            "name": "flatten",
            "variableName": "flattenReplies"
        } as any),
        (v28 /*: any*/)
    ], v40 = ({
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v41 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v3 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v4 /*: any*/),
                    (v30 /*: any*/),
                    (v36 /*: any*/),
                    (v12 /*: any*/),
                    (v31 /*: any*/),
                    (v14 /*: any*/),
                    (v11 /*: any*/),
                    (v5 /*: any*/),
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    (v7 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v35 /*: any*/),
                    (v9 /*: any*/),
                    (v20 /*: any*/),
                    (v25 /*: any*/),
                    (v26 /*: any*/),
                    (v32 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v42 = [
        "orderBy"
    ], v43 = ({
        "alias": null,
        "args": (v39 /*: any*/),
        "filters": (v42 /*: any*/),
        "handle": "connection",
        "key": "ReplyList_replies",
        "kind": "LinkedHandle",
        "name": "replies"
    } as any), v44 = ({
        "condition": "flattenReplies",
        "kind": "Condition",
        "passingValue": false,
        "selections": (v38 /*: any*/)
    } as any), v45 = ({
        "condition": "flattenReplies",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": null,
                "args": (v39 /*: any*/),
                "concreteType": "CommentsConnection",
                "kind": "LinkedField",
                "name": "replies",
                "plural": false,
                "selections": [
                    (v41 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "CommentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Comment",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    (v4 /*: any*/),
                                    (v30 /*: any*/),
                                    (v36 /*: any*/),
                                    (v12 /*: any*/),
                                    (v31 /*: any*/),
                                    (v14 /*: any*/),
                                    (v11 /*: any*/),
                                    (v5 /*: any*/),
                                    (v15 /*: any*/),
                                    (v16 /*: any*/),
                                    (v7 /*: any*/),
                                    (v33 /*: any*/),
                                    (v34 /*: any*/),
                                    (v17 /*: any*/),
                                    (v18 /*: any*/),
                                    (v19 /*: any*/),
                                    (v35 /*: any*/),
                                    (v9 /*: any*/),
                                    (v20 /*: any*/),
                                    (v25 /*: any*/),
                                    (v26 /*: any*/),
                                    (v32 /*: any*/),
                                    (v21 /*: any*/)
                                ],
                                "storageKey": null
                            },
                            (v21 /*: any*/),
                            (v3 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v40 /*: any*/)
                ],
                "storageKey": null
            },
            (v43 /*: any*/)
        ]
    } as any), v46 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v3 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v4 /*: any*/),
                    (v30 /*: any*/),
                    (v36 /*: any*/),
                    (v12 /*: any*/),
                    (v31 /*: any*/),
                    (v14 /*: any*/),
                    (v11 /*: any*/),
                    (v5 /*: any*/),
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    (v7 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v35 /*: any*/),
                    (v9 /*: any*/),
                    (v20 /*: any*/),
                    (v25 /*: any*/),
                    (v26 /*: any*/),
                    (v32 /*: any*/),
                    (v44 /*: any*/),
                    (v45 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v47 = ({
        "alias": null,
        "args": (v29 /*: any*/),
        "filters": (v42 /*: any*/),
        "handle": "connection",
        "key": "ReplyList_replies",
        "kind": "LinkedHandle",
        "name": "replies"
    } as any), v48 = ({
        "alias": null,
        "args": (v29 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": [
            (v46 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v4 /*: any*/),
                            (v30 /*: any*/),
                            (v36 /*: any*/),
                            (v12 /*: any*/),
                            (v31 /*: any*/),
                            (v14 /*: any*/),
                            (v11 /*: any*/),
                            (v5 /*: any*/),
                            (v15 /*: any*/),
                            (v16 /*: any*/),
                            (v7 /*: any*/),
                            (v33 /*: any*/),
                            (v34 /*: any*/),
                            (v17 /*: any*/),
                            (v18 /*: any*/),
                            (v19 /*: any*/),
                            (v35 /*: any*/),
                            (v9 /*: any*/),
                            (v20 /*: any*/),
                            (v25 /*: any*/),
                            (v26 /*: any*/),
                            (v32 /*: any*/),
                            (v21 /*: any*/),
                            (v44 /*: any*/),
                            (v45 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v3 /*: any*/)
                ],
                "storageKey": null
            },
            (v40 /*: any*/)
        ],
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
    } as any), v49 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v3 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v4 /*: any*/),
                    (v30 /*: any*/),
                    (v36 /*: any*/),
                    (v12 /*: any*/),
                    (v31 /*: any*/),
                    (v14 /*: any*/),
                    (v11 /*: any*/),
                    (v5 /*: any*/),
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    (v7 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v35 /*: any*/),
                    (v9 /*: any*/),
                    (v20 /*: any*/),
                    (v25 /*: any*/),
                    (v26 /*: any*/),
                    (v32 /*: any*/),
                    (v48 /*: any*/),
                    (v47 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v50 = ({
        "alias": null,
        "args": (v29 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": [
            (v49 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v4 /*: any*/),
                            (v30 /*: any*/),
                            (v36 /*: any*/),
                            (v12 /*: any*/),
                            (v31 /*: any*/),
                            (v14 /*: any*/),
                            (v11 /*: any*/),
                            (v5 /*: any*/),
                            (v15 /*: any*/),
                            (v16 /*: any*/),
                            (v7 /*: any*/),
                            (v33 /*: any*/),
                            (v34 /*: any*/),
                            (v17 /*: any*/),
                            (v18 /*: any*/),
                            (v19 /*: any*/),
                            (v35 /*: any*/),
                            (v9 /*: any*/),
                            (v20 /*: any*/),
                            (v25 /*: any*/),
                            (v26 /*: any*/),
                            (v32 /*: any*/),
                            (v48 /*: any*/),
                            (v47 /*: any*/),
                            (v21 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v3 /*: any*/)
                ],
                "storageKey": null
            },
            (v40 /*: any*/)
        ],
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
    } as any), v51 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v3 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v4 /*: any*/),
                    (v30 /*: any*/),
                    (v36 /*: any*/),
                    (v12 /*: any*/),
                    (v31 /*: any*/),
                    (v14 /*: any*/),
                    (v11 /*: any*/),
                    (v5 /*: any*/),
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    (v7 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v35 /*: any*/),
                    (v9 /*: any*/),
                    (v20 /*: any*/),
                    (v25 /*: any*/),
                    (v26 /*: any*/),
                    (v32 /*: any*/),
                    (v50 /*: any*/),
                    (v47 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v52 = ({
        "alias": null,
        "args": (v29 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": [
            (v51 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v4 /*: any*/),
                            (v30 /*: any*/),
                            (v36 /*: any*/),
                            (v12 /*: any*/),
                            (v31 /*: any*/),
                            (v14 /*: any*/),
                            (v11 /*: any*/),
                            (v5 /*: any*/),
                            (v15 /*: any*/),
                            (v16 /*: any*/),
                            (v7 /*: any*/),
                            (v33 /*: any*/),
                            (v34 /*: any*/),
                            (v17 /*: any*/),
                            (v18 /*: any*/),
                            (v19 /*: any*/),
                            (v35 /*: any*/),
                            (v9 /*: any*/),
                            (v20 /*: any*/),
                            (v25 /*: any*/),
                            (v26 /*: any*/),
                            (v32 /*: any*/),
                            (v50 /*: any*/),
                            (v47 /*: any*/),
                            (v21 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v3 /*: any*/)
                ],
                "storageKey": null
            },
            (v40 /*: any*/)
        ],
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
    } as any), v53 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v3 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v4 /*: any*/),
                    (v30 /*: any*/),
                    (v36 /*: any*/),
                    (v12 /*: any*/),
                    (v31 /*: any*/),
                    (v14 /*: any*/),
                    (v11 /*: any*/),
                    (v5 /*: any*/),
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    (v7 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v35 /*: any*/),
                    (v9 /*: any*/),
                    (v20 /*: any*/),
                    (v25 /*: any*/),
                    (v26 /*: any*/),
                    (v32 /*: any*/),
                    (v52 /*: any*/),
                    (v47 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v54 = ({
        "alias": null,
        "args": (v29 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": [
            (v53 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v4 /*: any*/),
                            (v30 /*: any*/),
                            (v36 /*: any*/),
                            (v12 /*: any*/),
                            (v31 /*: any*/),
                            (v14 /*: any*/),
                            (v11 /*: any*/),
                            (v5 /*: any*/),
                            (v15 /*: any*/),
                            (v16 /*: any*/),
                            (v7 /*: any*/),
                            (v33 /*: any*/),
                            (v34 /*: any*/),
                            (v17 /*: any*/),
                            (v18 /*: any*/),
                            (v19 /*: any*/),
                            (v35 /*: any*/),
                            (v9 /*: any*/),
                            (v20 /*: any*/),
                            (v25 /*: any*/),
                            (v26 /*: any*/),
                            (v32 /*: any*/),
                            (v52 /*: any*/),
                            (v47 /*: any*/),
                            (v21 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v3 /*: any*/)
                ],
                "storageKey": null
            },
            (v40 /*: any*/)
        ],
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
    } as any), v55 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v3 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v4 /*: any*/),
                    (v30 /*: any*/),
                    (v36 /*: any*/),
                    (v12 /*: any*/),
                    (v31 /*: any*/),
                    (v14 /*: any*/),
                    (v11 /*: any*/),
                    (v5 /*: any*/),
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    (v7 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v35 /*: any*/),
                    (v9 /*: any*/),
                    (v20 /*: any*/),
                    (v25 /*: any*/),
                    (v26 /*: any*/),
                    (v32 /*: any*/),
                    (v54 /*: any*/),
                    (v47 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any);
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "CreateCommentReplyMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v2 /*: any*/),
                    "concreteType": "CreateCommentReplyPayload",
                    "kind": "LinkedField",
                    "name": "createCommentReply",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CommentEdge",
                            "kind": "LinkedField",
                            "name": "edge",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        (v5 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Story",
                                            "kind": "LinkedField",
                                            "name": "story",
                                            "plural": false,
                                            "selections": [
                                                (v6 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Comment",
                                            "kind": "LinkedField",
                                            "name": "parent",
                                            "plural": false,
                                            "selections": [
                                                (v4 /*: any*/),
                                                (v7 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "AllCommentsTabCommentContainer_comment"
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v8 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "CreateCommentReplyMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v2 /*: any*/),
                    "concreteType": "CreateCommentReplyPayload",
                    "kind": "LinkedField",
                    "name": "createCommentReply",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CommentEdge",
                            "kind": "LinkedField",
                            "name": "edge",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        (v9 /*: any*/),
                                        (v12 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Comment",
                                            "kind": "LinkedField",
                                            "name": "parent",
                                            "plural": false,
                                            "selections": [
                                                (v4 /*: any*/),
                                                (v13 /*: any*/),
                                                (v7 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v14 /*: any*/),
                                        (v11 /*: any*/),
                                        (v5 /*: any*/),
                                        (v15 /*: any*/),
                                        (v16 /*: any*/),
                                        (v7 /*: any*/),
                                        (v17 /*: any*/),
                                        (v18 /*: any*/),
                                        (v19 /*: any*/),
                                        (v20 /*: any*/),
                                        (v25 /*: any*/),
                                        (v26 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Story",
                                            "kind": "LinkedField",
                                            "name": "story",
                                            "plural": false,
                                            "selections": [
                                                (v22 /*: any*/),
                                                (v4 /*: any*/),
                                                (v6 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": (v29 /*: any*/),
                                            "concreteType": "CommentsConnection",
                                            "kind": "LinkedField",
                                            "name": "replies",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "CommentEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Comment",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                (v4 /*: any*/),
                                                                (v30 /*: any*/),
                                                                (v12 /*: any*/),
                                                                (v31 /*: any*/),
                                                                (v14 /*: any*/),
                                                                (v11 /*: any*/),
                                                                (v5 /*: any*/),
                                                                (v15 /*: any*/),
                                                                (v16 /*: any*/),
                                                                (v7 /*: any*/),
                                                                (v17 /*: any*/),
                                                                (v18 /*: any*/),
                                                                (v19 /*: any*/),
                                                                (v9 /*: any*/),
                                                                (v20 /*: any*/),
                                                                (v25 /*: any*/),
                                                                (v26 /*: any*/),
                                                                (v32 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": (v29 /*: any*/),
                                                                    "concreteType": "CommentsConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "replies",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "CommentEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Comment",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v4 /*: any*/),
                                                                                        (v30 /*: any*/),
                                                                                        (v12 /*: any*/),
                                                                                        (v31 /*: any*/),
                                                                                        (v14 /*: any*/),
                                                                                        (v11 /*: any*/),
                                                                                        (v5 /*: any*/),
                                                                                        (v15 /*: any*/),
                                                                                        (v16 /*: any*/),
                                                                                        (v7 /*: any*/),
                                                                                        (v17 /*: any*/),
                                                                                        (v18 /*: any*/),
                                                                                        (v19 /*: any*/),
                                                                                        (v9 /*: any*/),
                                                                                        (v20 /*: any*/),
                                                                                        (v25 /*: any*/),
                                                                                        (v26 /*: any*/),
                                                                                        (v32 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": (v29 /*: any*/),
                                                                                            "concreteType": "CommentsConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "replies",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "CommentEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "Comment",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                (v4 /*: any*/),
                                                                                                                (v30 /*: any*/),
                                                                                                                (v12 /*: any*/),
                                                                                                                (v31 /*: any*/),
                                                                                                                (v14 /*: any*/),
                                                                                                                (v11 /*: any*/),
                                                                                                                (v5 /*: any*/),
                                                                                                                (v15 /*: any*/),
                                                                                                                (v16 /*: any*/),
                                                                                                                (v7 /*: any*/),
                                                                                                                (v17 /*: any*/),
                                                                                                                (v18 /*: any*/),
                                                                                                                (v19 /*: any*/),
                                                                                                                (v9 /*: any*/),
                                                                                                                (v20 /*: any*/),
                                                                                                                (v25 /*: any*/),
                                                                                                                (v26 /*: any*/),
                                                                                                                (v32 /*: any*/),
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": (v29 /*: any*/),
                                                                                                                    "concreteType": "CommentsConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "replies",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "concreteType": "CommentEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "alias": null,
                                                                                                                                    "args": null,
                                                                                                                                    "concreteType": "Comment",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        (v4 /*: any*/),
                                                                                                                                        (v30 /*: any*/),
                                                                                                                                        (v12 /*: any*/),
                                                                                                                                        (v31 /*: any*/),
                                                                                                                                        (v14 /*: any*/),
                                                                                                                                        (v11 /*: any*/),
                                                                                                                                        (v5 /*: any*/),
                                                                                                                                        (v15 /*: any*/),
                                                                                                                                        (v16 /*: any*/),
                                                                                                                                        (v7 /*: any*/),
                                                                                                                                        (v17 /*: any*/),
                                                                                                                                        (v18 /*: any*/),
                                                                                                                                        (v19 /*: any*/),
                                                                                                                                        (v9 /*: any*/),
                                                                                                                                        (v20 /*: any*/),
                                                                                                                                        (v25 /*: any*/),
                                                                                                                                        (v26 /*: any*/),
                                                                                                                                        (v32 /*: any*/),
                                                                                                                                        {
                                                                                                                                            "alias": null,
                                                                                                                                            "args": (v29 /*: any*/),
                                                                                                                                            "concreteType": "CommentsConnection",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "replies",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "alias": null,
                                                                                                                                                    "args": null,
                                                                                                                                                    "concreteType": "CommentEdge",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "edges",
                                                                                                                                                    "plural": true,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "alias": null,
                                                                                                                                                            "args": null,
                                                                                                                                                            "concreteType": "Comment",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "node",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                (v4 /*: any*/),
                                                                                                                                                                (v30 /*: any*/),
                                                                                                                                                                (v12 /*: any*/),
                                                                                                                                                                (v31 /*: any*/),
                                                                                                                                                                (v14 /*: any*/),
                                                                                                                                                                (v11 /*: any*/),
                                                                                                                                                                (v5 /*: any*/),
                                                                                                                                                                (v15 /*: any*/),
                                                                                                                                                                (v16 /*: any*/),
                                                                                                                                                                (v7 /*: any*/),
                                                                                                                                                                (v17 /*: any*/),
                                                                                                                                                                (v18 /*: any*/),
                                                                                                                                                                (v19 /*: any*/),
                                                                                                                                                                (v9 /*: any*/),
                                                                                                                                                                (v20 /*: any*/),
                                                                                                                                                                (v25 /*: any*/),
                                                                                                                                                                (v26 /*: any*/),
                                                                                                                                                                (v32 /*: any*/),
                                                                                                                                                                {
                                                                                                                                                                    "alias": null,
                                                                                                                                                                    "args": (v29 /*: any*/),
                                                                                                                                                                    "concreteType": "CommentsConnection",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "replies",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        {
                                                                                                                                                                            "alias": null,
                                                                                                                                                                            "args": null,
                                                                                                                                                                            "concreteType": "CommentEdge",
                                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                                            "name": "edges",
                                                                                                                                                                            "plural": true,
                                                                                                                                                                            "selections": [
                                                                                                                                                                                {
                                                                                                                                                                                    "alias": null,
                                                                                                                                                                                    "args": null,
                                                                                                                                                                                    "concreteType": "Comment",
                                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                                    "name": "node",
                                                                                                                                                                                    "plural": false,
                                                                                                                                                                                    "selections": [
                                                                                                                                                                                        (v4 /*: any*/),
                                                                                                                                                                                        (v30 /*: any*/),
                                                                                                                                                                                        (v12 /*: any*/),
                                                                                                                                                                                        (v31 /*: any*/),
                                                                                                                                                                                        (v14 /*: any*/),
                                                                                                                                                                                        (v11 /*: any*/),
                                                                                                                                                                                        (v5 /*: any*/),
                                                                                                                                                                                        (v15 /*: any*/),
                                                                                                                                                                                        (v16 /*: any*/),
                                                                                                                                                                                        (v7 /*: any*/),
                                                                                                                                                                                        (v17 /*: any*/),
                                                                                                                                                                                        (v18 /*: any*/),
                                                                                                                                                                                        (v19 /*: any*/),
                                                                                                                                                                                        (v9 /*: any*/),
                                                                                                                                                                                        (v20 /*: any*/),
                                                                                                                                                                                        (v25 /*: any*/),
                                                                                                                                                                                        (v26 /*: any*/),
                                                                                                                                                                                        (v32 /*: any*/),
                                                                                                                                                                                        (v21 /*: any*/),
                                                                                                                                                                                        (v37 /*: any*/),
                                                                                                                                                                                        {
                                                                                                                                                                                            "condition": "flattenReplies",
                                                                                                                                                                                            "kind": "Condition",
                                                                                                                                                                                            "passingValue": false,
                                                                                                                                                                                            "selections": [
                                                                                                                                                                                                {
                                                                                                                                                                                                    "kind": "ClientExtension",
                                                                                                                                                                                                    "selections": (v38 /*: any*/)
                                                                                                                                                                                                }
                                                                                                                                                                                            ]
                                                                                                                                                                                        },
                                                                                                                                                                                        {
                                                                                                                                                                                            "condition": "flattenReplies",
                                                                                                                                                                                            "kind": "Condition",
                                                                                                                                                                                            "passingValue": true,
                                                                                                                                                                                            "selections": [
                                                                                                                                                                                                {
                                                                                                                                                                                                    "alias": null,
                                                                                                                                                                                                    "args": (v39 /*: any*/),
                                                                                                                                                                                                    "concreteType": "CommentsConnection",
                                                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                                                    "name": "replies",
                                                                                                                                                                                                    "plural": false,
                                                                                                                                                                                                    "selections": [
                                                                                                                                                                                                        {
                                                                                                                                                                                                            "alias": null,
                                                                                                                                                                                                            "args": null,
                                                                                                                                                                                                            "concreteType": "CommentEdge",
                                                                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                                                                            "name": "edges",
                                                                                                                                                                                                            "plural": true,
                                                                                                                                                                                                            "selections": [
                                                                                                                                                                                                                {
                                                                                                                                                                                                                    "alias": null,
                                                                                                                                                                                                                    "args": null,
                                                                                                                                                                                                                    "concreteType": "Comment",
                                                                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                                                                    "name": "node",
                                                                                                                                                                                                                    "plural": false,
                                                                                                                                                                                                                    "selections": [
                                                                                                                                                                                                                        (v4 /*: any*/),
                                                                                                                                                                                                                        (v30 /*: any*/),
                                                                                                                                                                                                                        (v12 /*: any*/),
                                                                                                                                                                                                                        (v31 /*: any*/),
                                                                                                                                                                                                                        (v14 /*: any*/),
                                                                                                                                                                                                                        (v11 /*: any*/),
                                                                                                                                                                                                                        (v5 /*: any*/),
                                                                                                                                                                                                                        (v15 /*: any*/),
                                                                                                                                                                                                                        (v16 /*: any*/),
                                                                                                                                                                                                                        (v7 /*: any*/),
                                                                                                                                                                                                                        (v17 /*: any*/),
                                                                                                                                                                                                                        (v18 /*: any*/),
                                                                                                                                                                                                                        (v19 /*: any*/),
                                                                                                                                                                                                                        (v9 /*: any*/),
                                                                                                                                                                                                                        (v20 /*: any*/),
                                                                                                                                                                                                                        (v25 /*: any*/),
                                                                                                                                                                                                                        (v26 /*: any*/),
                                                                                                                                                                                                                        (v32 /*: any*/),
                                                                                                                                                                                                                        (v21 /*: any*/),
                                                                                                                                                                                                                        (v37 /*: any*/)
                                                                                                                                                                                                                    ],
                                                                                                                                                                                                                    "storageKey": null
                                                                                                                                                                                                                },
                                                                                                                                                                                                                (v21 /*: any*/),
                                                                                                                                                                                                                (v3 /*: any*/)
                                                                                                                                                                                                            ],
                                                                                                                                                                                                            "storageKey": null
                                                                                                                                                                                                        },
                                                                                                                                                                                                        (v40 /*: any*/),
                                                                                                                                                                                                        {
                                                                                                                                                                                                            "kind": "ClientExtension",
                                                                                                                                                                                                            "selections": [
                                                                                                                                                                                                                (v41 /*: any*/)
                                                                                                                                                                                                            ]
                                                                                                                                                                                                        }
                                                                                                                                                                                                    ],
                                                                                                                                                                                                    "storageKey": null
                                                                                                                                                                                                },
                                                                                                                                                                                                (v43 /*: any*/)
                                                                                                                                                                                            ]
                                                                                                                                                                                        }
                                                                                                                                                                                    ],
                                                                                                                                                                                    "storageKey": null
                                                                                                                                                                                },
                                                                                                                                                                                (v3 /*: any*/)
                                                                                                                                                                            ],
                                                                                                                                                                            "storageKey": null
                                                                                                                                                                        },
                                                                                                                                                                        (v40 /*: any*/),
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "ClientExtension",
                                                                                                                                                                            "selections": [
                                                                                                                                                                                (v46 /*: any*/)
                                                                                                                                                                            ]
                                                                                                                                                                        }
                                                                                                                                                                    ],
                                                                                                                                                                    "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                                                                                                                                                },
                                                                                                                                                                (v47 /*: any*/),
                                                                                                                                                                (v21 /*: any*/),
                                                                                                                                                                (v37 /*: any*/)
                                                                                                                                                            ],
                                                                                                                                                            "storageKey": null
                                                                                                                                                        },
                                                                                                                                                        (v3 /*: any*/)
                                                                                                                                                    ],
                                                                                                                                                    "storageKey": null
                                                                                                                                                },
                                                                                                                                                (v40 /*: any*/),
                                                                                                                                                {
                                                                                                                                                    "kind": "ClientExtension",
                                                                                                                                                    "selections": [
                                                                                                                                                        (v49 /*: any*/)
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                                                                                                                        },
                                                                                                                                        (v47 /*: any*/),
                                                                                                                                        (v21 /*: any*/),
                                                                                                                                        (v37 /*: any*/)
                                                                                                                                    ],
                                                                                                                                    "storageKey": null
                                                                                                                                },
                                                                                                                                (v3 /*: any*/)
                                                                                                                            ],
                                                                                                                            "storageKey": null
                                                                                                                        },
                                                                                                                        (v40 /*: any*/),
                                                                                                                        {
                                                                                                                            "kind": "ClientExtension",
                                                                                                                            "selections": [
                                                                                                                                (v51 /*: any*/)
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                                                                                                },
                                                                                                                (v47 /*: any*/),
                                                                                                                (v21 /*: any*/),
                                                                                                                (v37 /*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        (v3 /*: any*/)
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                (v40 /*: any*/),
                                                                                                {
                                                                                                    "kind": "ClientExtension",
                                                                                                    "selections": [
                                                                                                        (v53 /*: any*/)
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                                                                        },
                                                                                        (v47 /*: any*/),
                                                                                        (v21 /*: any*/),
                                                                                        (v37 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v3 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v40 /*: any*/),
                                                                        {
                                                                            "kind": "ClientExtension",
                                                                            "selections": [
                                                                                (v55 /*: any*/)
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                                                },
                                                                (v47 /*: any*/),
                                                                (v21 /*: any*/),
                                                                (v37 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v3 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v40 /*: any*/),
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CommentEdge",
                                                            "kind": "LinkedField",
                                                            "name": "viewNewEdges",
                                                            "plural": true,
                                                            "selections": [
                                                                (v3 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Comment",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v4 /*: any*/),
                                                                        (v30 /*: any*/),
                                                                        (v36 /*: any*/),
                                                                        (v12 /*: any*/),
                                                                        (v31 /*: any*/),
                                                                        (v14 /*: any*/),
                                                                        (v11 /*: any*/),
                                                                        (v5 /*: any*/),
                                                                        (v15 /*: any*/),
                                                                        (v16 /*: any*/),
                                                                        (v7 /*: any*/),
                                                                        (v33 /*: any*/),
                                                                        (v34 /*: any*/),
                                                                        (v17 /*: any*/),
                                                                        (v18 /*: any*/),
                                                                        (v19 /*: any*/),
                                                                        (v35 /*: any*/),
                                                                        (v9 /*: any*/),
                                                                        (v20 /*: any*/),
                                                                        (v25 /*: any*/),
                                                                        (v26 /*: any*/),
                                                                        (v32 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": (v29 /*: any*/),
                                                                            "concreteType": "CommentsConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "replies",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v55 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "CommentEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "Comment",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v4 /*: any*/),
                                                                                                (v30 /*: any*/),
                                                                                                (v36 /*: any*/),
                                                                                                (v12 /*: any*/),
                                                                                                (v31 /*: any*/),
                                                                                                (v14 /*: any*/),
                                                                                                (v11 /*: any*/),
                                                                                                (v5 /*: any*/),
                                                                                                (v15 /*: any*/),
                                                                                                (v16 /*: any*/),
                                                                                                (v7 /*: any*/),
                                                                                                (v33 /*: any*/),
                                                                                                (v34 /*: any*/),
                                                                                                (v17 /*: any*/),
                                                                                                (v18 /*: any*/),
                                                                                                (v19 /*: any*/),
                                                                                                (v35 /*: any*/),
                                                                                                (v9 /*: any*/),
                                                                                                (v20 /*: any*/),
                                                                                                (v25 /*: any*/),
                                                                                                (v26 /*: any*/),
                                                                                                (v32 /*: any*/),
                                                                                                (v54 /*: any*/),
                                                                                                (v47 /*: any*/),
                                                                                                (v21 /*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        },
                                                                                        (v3 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v40 /*: any*/)
                                                                            ],
                                                                            "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                                                        },
                                                                        (v47 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                        },
                                        (v47 /*: any*/),
                                        (v37 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v8 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "f87493f46f23a2d9c1e1324337ade74b",
            "metadata": {},
            "name": "CreateCommentReplyMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '173f875bd3dfe1fd9e2dfe22b915153b';
export default node;
